<template>
  <!-- <div class="f-center h-100 csst csst_nm" @click.stop> -->
  <Checkbox
    class="csst"
    :value="value"
    :indeterminate="indeterminate"
    style="
      --icon-size: 1.25rem;
      --clr-disabled: var(--clr-grey-2);
      --clr-enabled: var(--clr-primary);
    "
    :style="checkboxStyle || ''"
    @click="$emit('click')"
  >
    <template #content>
      <div
        class="csst_content text-nowrap"
        style="left: calc(100% + 0.5rem)"
      >
        {{ value ? $t('common.unselect_all') : $t('common.select_all') }}
      </div>
    </template>
  </Checkbox>
  <!-- </div> -->
</template>

<script>
import Checkbox from '@/components/Common/Checkbox/Checkbox'

export default {
  name: 'TableMainCheckbox',
  components: {
    Checkbox,
  },
  props: {
    value: Boolean,
    indeterminate: Boolean,
    checkboxStyle: String,
  }, 
 emits: ['click'],
}
</script>

<style></style>
